import { useMemo, useState } from "react";
import { symptomItems } from "@/mocks/homeData";

const filters = ["全部", "连接层", "域名层", "页面层", "网络层", "安全层"];

const levelStyles: Record<string, string> = {
  连接层: "bg-primary-100 text-primary-800",
  域名层: "bg-accent-100 text-accent-800",
  页面层: "bg-secondary-100 text-secondary-800",
  网络层: "bg-primary-100 text-primary-800",
  安全层: "bg-accent-100 text-accent-800",
};

export default function Symptoms() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? symptomItems : symptomItems.filter((s) => s.level === active)),
    [active],
  );

  return (
    <section id="symptoms" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-700 uppercase tracking-wider">
            <i className="ri-list-check-2"></i>
            Symptoms
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            先对照：秋霞影院打不开时的常见现象
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            「进不去」只是一个笼统的说法，具体的表现其实各不相同。下面的现象按发生环节归类，
            你可以先找到和自己最接近的那一条，再顺着它去看对应的原因。
          </p>
        </div>

        <div className="mt-7 flex flex-wrap items-center gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              aria-pressed={active === f}
              className={`whitespace-nowrap px-3.5 py-2 rounded-full text-xs md:text-sm border transition-colors cursor-pointer ${
                active === f
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-50 border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {f}
            </button>
          ))}
          <span className="ml-auto text-xs text-foreground-500">共 {list.length} 条现象</span>
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {list.map((item) => (
            <article
              key={item.title}
              className="rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-6 flex flex-col hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="w-11 h-11 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center text-xl shrink-0">
                  <i className={item.icon}></i>
                </span>
                <span className={`shrink-0 px-2.5 py-1 rounded-full text-[11px] font-medium ${levelStyles[item.level]}`}>
                  {item.level}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}